@if (profileLoading()) {
	<lb-loader message="Loading Profile"></lb-loader>
} @else {
	<lb-profile-page [profile]="profile()" [profileUpdating]="profileUpdating()" (cancel)="onCancel()" (save)="onSave($event)"></lb-profile-page>
}
